<div class="workflow-container" [class.screenblur]="workflowSpinner">
  <ng-container *ngIf="workflowEntityList.length">
    
 
    <!-- Search Bar -->
    <div class="search-container mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Search Workflows</mat-label>
        <input matInput [formControl]="searchControl" placeholder="Type to search...">

        <mat-icon *ngIf="!searchControl.value" matSuffix>search</mat-icon>
        <button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  
    <!-- No Results Message -->
    <div *ngIf="displayedWorkflows.length === 0" class="no-results-container text-center p-4">
      <mat-icon class="large-icon">search_off</mat-icon>
      <p>No workflows found matching your search criteria.</p>
    </div>
  
    <!-- Workflow Accordion -->
    <mat-accordion class="mat-list-custom" togglePosition="before" displayMode="flat" [multi]="false" >
      <ng-container *ngFor="let workflow of displayedWorkflows; let index = index;">
        <mat-expansion-panel [expanded]="workflow.open" class="mx-2 mb-1" (closed)="toggleWorkFlow(false, workflow, index, eventTypes.closed)" (opened)="toggleWorkFlow(true, workflow, index, eventTypes.click)" >
          <mat-expansion-panel-header [class.active]="workflow.open" class="mat-list-item" mat-ripple >
            <mat-panel-title class="item-fill w-75 me-0">
              <span class="text-ellipsis">{{ workflow.workflow_name | titlecase }}</span>
            </mat-panel-title>
            <div class="item-end control-buttons">
              @if([appPermissions.editEntity,permissionsActions.edit]|builderPermissions){
                <button mat-icon-button (click)="$event.stopPropagation();editWorkFlow(workflow.worflow_id,index)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="$event.stopPropagation();openWorkFlowDeleteModal(deleteWorkFlowPopUp, workflow.worflow_id, workflow.workflow_name, entity.entity_id)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </mat-expansion-panel-header>
          <ng-container *ngIf="workflow.open">
            <div *ngIf="stageSpinner && workflow.open" class="imageCenter">
              <mat-spinner diameter="30" [id]="workflow.worflow_id"></mat-spinner>
            </div>
            <ng-container *ngIf="workflowEntityList.length > 0 && !stageSpinner">
              <mat-list *ngFor="let stage of stageWorkFlowList; let index = index">
                <mat-list-item (click)="setStageConfiguration(stage.stage_id, workflow.worflow_id, entity.entity_id, true, stage)" [class.selected]="selectedStageId === stage.stage_id">
                  <span class="d-flex align-items-center justify-content-between gap-3">
                    <span class="text-ellipsis" [matTooltip]="stage.stage_name">{{ stage.stage_name | titlecase }}</span>
                    <div class="item-end control-buttons">
                      @if([appPermissions.editEntity,permissionsActions.edit]|builderPermissions){
                        <button mat-icon-button color="warn" class="mat-small" (click)="$event.stopPropagation();openWorkFlowDeleteModal(deleteStagePopUp, stage.stage_id, stage.stage_name, entity.entity_id)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </span>
                </mat-list-item>
              </mat-list>
            </ng-container>
            @if([appPermissions.editEntity,permissionsActions.edit]|builderPermissions){
              <button mat-stroked-button color="primary" class="add-button w-100 mt-4" (click)="setStageConfiguration('', workflow.worflow_id, entity.entity_id, false, '')">
                <mat-icon>add</mat-icon> Add Stage
              </button>
            }
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  
    <!-- Material Paginator -->
    <mat-paginator 
      *ngIf="totalItems > 0"
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)"
      aria-label="Select page">
    </mat-paginator>


   
</ng-container>
@if([appPermissions.editEntity,permissionsActions.edit]|builderPermissions){
  <button mat-stroked-button color="primary" class="add-button w-100 mt-4" (click)="openWorkFlowModal(addWorkFlowPopUp, false, entity.entity_id, entity.entity_name)">
    <mat-icon>add</mat-icon> Add WorkFlow
  </button>
}
</div>
<div class="sp inner-container"*ngIf="workflowSpinner">
  <div class="imageCenter">
    <mat-spinner [diameter]="40"[id]="'workflowspinner'" ></mat-spinner>
  </div>
  </div>




  <ng-template #deleteStagePopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="deleteStageFromWorkFlow(workFlowDeleteEntity.deleteId)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12 ">
                    <h2 class="header-with-underline">
                        <span>Delete WorkFlow</span>
                    </h2>
                </div>
                <div class="col-12 text-center ">
                    <span>Before deleting the <b>{{workFlowDeleteEntity.deleteName| titlecase}}</b> stage, please note that it will permanently remove the
                        stage and their associated configuarations. Additionally, any references to this workflow data may be lost. Please proceed with caution</span>
                </div>
                <div class="col-12  text-center mt-1">
                    <mat-icon class="delete-icon">warning</mat-icon>
                </div>
                <div class="col-12 text-center">
                    <h6 class="text-danger" style="font-size: medium;">Are you sure to delete?</h6>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">No</button>
            <button mat-raised-button color="primary" (click)="deleteStageFromWorkFlow(workFlowDeleteEntity.deleteId)">Yes</button>
        </mat-dialog-actions>
    </div>
</ng-template>


<ng-template #deleteWorkFlowPopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="deleteWorkFlow(workFlowDeleteEntity.deleteId, workFlowDeleteEntity.entityId)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12 ">
                    <h2 class="header-with-underline">
                        <span>Delete WorkFlow</span>
                    </h2>
                </div>
                <div class="col-12 text-center ">
                    <span>Before deleting the <b>{{workFlowDeleteEntity.deleteName| titlecase}}</b> workflow, please note that it will permanently remove the 
                        workflow, stages and their associated configuarations. Additionally, any references to this workflow data may be lost. Please proceed with caution</span>
                </div>
                <div class="col-12  text-center mt-1">
                    <mat-icon class="delete-icon">warning</mat-icon>
                </div>
                <div class="col-12 text-center">
                    <h6 class="text-danger" style="font-size: medium;">Are you sure to delete?</h6>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">Cancel</button>
            <button mat-raised-button color="primary" (click)="deleteWorkFlow(workFlowDeleteEntity.deleteId, workFlowDeleteEntity.entityId)">Yes</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<!-- Add WorkFlow -->
<ng-template #addWorkFlowPopUp>
  <div (keydown.escape)="closeTemplate()">
      <mat-dialog-content class="add-page-dailog">
          <div class="row">
              <div class="col-12" [formGroup]="workFlowForm">
                  <h4>
                      <span *ngIf="!isEdit">Add WorkFlow</span>
                      <span *ngIf="isEdit">Edit WorkFlow</span>
                  </h4>
                  <mat-form-field class="w-100" appearance="outline">
                      <mat-label>Title</mat-label>
                      <input matInput placeholder="WorkFlow Name" formControlName="name" />
                      <mat-hint class="error-message" *ngIf="!isEntityNameUnique">workflow name already exist</mat-hint>
                  </mat-form-field>

                  <mat-label *ngIf="!isEdit">Stages</mat-label><br>
                  <ng-container formArrayName="stages" *ngIf="!isEdit">
                      <ng-container *ngFor="let stage of stageArray.controls; let i = index">
                          <mat-form-field class="w-75" appearance="outline" [formGroupName]="i" [class.mt-3]="i === 0">
                              <mat-label>Stage Title</mat-label>
                              <input matInput placeholder="Stage Name" formControlName="name" />
                              <mat-hint class="error-message" *ngIf="!isEntityNameUnique">Stage name already exist</mat-hint>
                          </mat-form-field>
                          <button mat-icon-button color="warn" class="bg-danger text-white mx-4" *ngIf="i > 1 && i != stageArray.controls.length - 1" (click)="deleteStage(i)"><mat-icon>delete</mat-icon></button>
                          <button mat-icon-button class="text-dark mx-4" *ngIf="i == stageArray.controls.length - 1" (click)="addStage()"><mat-icon>add</mat-icon></button>
                      </ng-container>
                  </ng-container>
              </div>
          </div>
      </mat-dialog-content>
      <mat-dialog-actions class="dailog-footer-buttons">
          <button mat-raised-button class="rounded-3" (click)="closeTemplate()">Cancel</button>
          <button mat-raised-button color="primary" class="rounded-3" [disabled]="workFlowForm.invalid" (click)="saveWorkFlow(popupEntity.entityId, isEdit)">Save</button>
      </mat-dialog-actions>
  </div>
</ng-template>